export default "__VITE_ASSET__C8yVA5CI__"